import { render, staticRenderFns } from "./TableHeader.vue?vue&type=template&id=63a6e09a&scoped=true"
import script from "./TableHeader.vue?vue&type=script&lang=ts"
export * from "./TableHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a6e09a",
  null
  
)

export default component.exports